const openQuickShopModal = (product) => {
// The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
//You can check the values by logging it.
// console.log(product);
console.log("clicked");

// Please put your functions here
}
//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick =() => {
window.tolstoyWidget.subscribe(
"tolstoy_spotlight_carousel_quick_shop_click",
(o) => {o.product && o.product.handle? openQuickShopModal(o.product): console.error("Product handle is not available in the event");},
{ disableDefault: !0 },
);
}
window.tolstoyWidget ? subscribeToQuickShopClick(): window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);

// const openQuickShopModal = (product) => {
//   console.log('Product data:', product);
  
//   // Check if product handle exists
//   if (!product || !product.handle) {
//     console.error("Product handle is not available");
//     return;
//   }
  
//   // Create modal HTML
//   const modalHTML = `
//     <div id="quick-shop-modal" style="
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       background: rgba(0,0,0,0.8);
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       z-index: 9999;
//     ">
//       <div style="
//         background: white;
//         padding: 20px;
//         border-radius: 10px;
//         max-width: 500px;
//         width: 90%;
//         max-height: 80vh;
//         overflow-y: auto;
//         position: relative;
//       ">
//         <button id="close-modal" style="
//           position: absolute;
//           top: 10px;
//           right: 15px;
//           background: none;
//           border: none;
//           font-size: 24px;
//           cursor: pointer;
//         ">&times;</button>
        
//         <div id="modal-content">
//           <div style="text-align: center; padding: 20px;">
//             Loading product...
//           </div>
//         </div>
//       </div>
//     </div>
//   `;
  
//   // Add modal to page
//   document.body.insertAdjacentHTML('beforeend', modalHTML);
  
//   // Add close functionality
//   document.getElementById('close-modal').addEventListener('click', closeQuickShopModal);
//   document.getElementById('quick-shop-modal').addEventListener('click', function(e) {
//     if (e.target === this) {
//       closeQuickShopModal();
//     }
//   });
  
//   // Load product data
//   loadProductInModal(product.handle);
// };

// const closeQuickShopModal = () => {
//   const modal = document.getElementById('quick-shop-modal');
//   if (modal) {
//     modal.remove();
//   }
// };

// const loadProductInModal = async (productHandle) => {
//   try {
//     // Fetch product data from Shopify
//     const response = await fetch(`/products/${productHandle}.js`);
//     const product = await response.json();
    
//     // Update modal content
//     const modalContent = document.getElementById('modal-content');
//     if (modalContent) {
//       modalContent.innerHTML = `
//         <div style="text-align: center;">
//           <img src="${product.featured_image}" alt="${product.title}" style="width: 100%; max-width: 300px; height: auto; margin-bottom: 15px;">
//           <h3 style="margin: 10px 0;">${product.title}</h3>
//           <p style="font-size: 18px; color: #333; margin: 10px 0;">
//             ${formatPrice(product.price)}
//           </p>
//           <div style="margin: 15px 0;">
//             ${product.description.substring(0, 150)}...
//           </div>
          
//           <form action="/cart/add" method="post" style="margin-top: 20px;">
//             <input type="hidden" name="id" value="${product.variants[0].id}">
            
//             ${product.variants.length > 1 ? createVariantSelector(product.variants) : ''}
            
//             <div style="margin: 15px 0;">
//               <label for="quantity">Quantity:</label>
//               <input type="number" id="quantity" name="quantity" value="1" min="1" style="width: 60px; margin-left: 10px; padding: 5px;">
//             </div>
            
//             <button type="submit" style="
//               background: #000;
//               color: white;
//               padding: 12px 30px;
//               border: none;
//               border-radius: 5px;
//               cursor: pointer;
//               font-size: 16px;
//               width: 100%;
//             ">
//               Add to Cart
//             </button>
//           </form>
          
//           <a href="/products/${productHandle}" style="
//             display: inline-block;
//             margin-top: 10px;
//             color: #666;
//             text-decoration: underline;
//           ">View Full Details</a>
//         </div>
//       `;
//     }
//   } catch (error) {
//     console.error('Error loading product:', error);
//     const modalContent = document.getElementById('modal-content');
//     if (modalContent) {
//       modalContent.innerHTML = '<p>Error loading product. Please try again.</p>';
//     }
//   }
// };

// const formatPrice = (priceInCents) => {
//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: 'USD'
//   }).format(priceInCents / 100);
// };

// const createVariantSelector = (variants) => {
//   let selector = '<select name="id" style="padding: 8px; margin: 10px 0; width: 100%;">';
//   variants.forEach(variant => {
//     selector += `<option value="${variant.id}" ${!variant.available ? 'disabled' : ''}>
//       ${variant.title} - ${formatPrice(variant.price)} ${!variant.available ? '(Sold Out)' : ''}
//     </option>`;
//   });
//   selector += '</select>';
//   return selector;
// };

// // Tolstoy subscription code (keep this as is)
// const subscribeToQuickShopClick = () => {
//   window.tolstoyWidget.subscribe(
//     "tolstoy_spotlight_carousel_quick_shop_click",
//     (o) => {
//       o.product && o.product.handle 
//         ? openQuickShopModal(o.product) 
//         : console.error("Product handle is not available in the event");
//     },
//     { disableDefault: true }
//   );
// };

// window.tolstoyWidget 
//   ? subscribeToQuickShopClick() 
//   : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);

// Maybe Final
// const openQuickShopModal = (product) => {
//   console.log('Product data:', product);
  
//   if (!product || !product.handle) {
//     console.error("Product handle is not available");
//     return;
//   }
  
//   // Create modal overlay
//   const modalHTML = `
//     <div id="quick-shop-modal" style="
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100vw;
//       height: 100vh;
//       background: rgba(0,0,0,0.8);
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       z-index: 9999;
//       font-family: Arial, sans-serif;
//     ">
//       <div id="modal-container" style="
//         background: white;
//         width: 90%;
//         max-width: 800px;
//         max-height: 90vh;
//         border-radius: 0;
//         position: relative;
//         display: flex;
//         overflow: hidden;
//       ">
//         <button id="close-modal" style="
//           position: absolute;
//           top: 15px;
//           right: 15px;
//           background: none;
//           border: none;
//           font-size: 28px;
//           cursor: pointer;
//           z-index: 10001;
//           color: #333;
//           width: 30px;
//           height: 30px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         ">&times;</button>
        
//         <div id="modal-content" style="
//           display: flex;
//           width: 100%;
//           min-height: 500px;
//         ">
//           <div style="
//             flex: 1;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             background: #f5f5f5;
//             padding: 20px;
//           ">
//             <div style="text-align: center; color: #999;">
//               Loading...
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
    
//     <style>
//       @media (max-width: 768px) {
//         #modal-container {
//           width: 95% !important;
//           max-width: none !important;
//           flex-direction: column !important;
//           max-height: 95vh !important;
//         }
//         #modal-content {
//           flex-direction: column !important;
//         }
//         .product-images {
//           height: 250px !important;
//         }
//         .product-details {
//           padding: 15px !important;
//         }
//       }
      
//       .color-swatch {
//         width: 35px;
//         height: 35px;
//         border-radius: 3px;
//         border: 2px solid transparent;
//         cursor: pointer;
//         margin: 3px;
//         position: relative;
//         transition: all 0.2s ease;
//       }
      
//       .color-swatch:hover {
//         transform: scale(1.05);
//         border-color: #333;
//       }
      
//       .color-swatch.selected {
//         border-color: #000;
//         transform: scale(1.1);
//       }
      
//       .color-swatch.new::after {
//         content: 'NEW';
//         position: absolute;
//         top: -8px;
//         left: -5px;
//         background: #ff0000;
//         color: white;
//         font-size: 8px;
//         padding: 1px 3px;
//         border-radius: 2px;
//         font-weight: bold;
//       }
      
//       .quantity-selector {
//         display: flex;
//         align-items: center;
//         border: 1px solid #ddd;
//         width: fit-content;
//       }
      
//       .quantity-btn {
//         background: none;
//         border: none;
//         width: 40px;
//         height: 40px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         cursor: pointer;
//         font-size: 18px;
//         color: #666;
//       }
      
//       .quantity-btn:hover {
//         background: #f5f5f5;
//       }
      
//       .quantity-input {
//         border: none;
//         width: 60px;
//         height: 40px;
//         text-align: center;
//         font-size: 16px;
//         outline: none;
//       }
      
//       .add-to-bag-btn {
//         background: #000;
//         color: white;
//         border: none;
//         padding: 15px 30px;
//         font-size: 16px;
//         font-weight: bold;
//         cursor: pointer;
//         width: 100%;
//         letter-spacing: 1px;
//         transition: background 0.3s ease;
//       }
      
//       .add-to-bag-btn:hover {
//         background: #333;
//       }
      
//       .add-to-bag-btn:disabled {
//         background: #ccc;
//         cursor: not-allowed;
//       }
//     </style>
//   `;
  
//   document.body.insertAdjacentHTML('beforeend', modalHTML);
//   document.body.style.overflow = 'hidden';
  
//   // Event listeners
//   document.getElementById('close-modal').addEventListener('click', closeQuickShopModal);
//   document.getElementById('quick-shop-modal').addEventListener('click', function(e) {
//     if (e.target === this) closeQuickShopModal();
//   });
  
//   // Load product
//   loadProductInModal(product.handle);
// };

// const closeQuickShopModal = () => {
//   const modal = document.getElementById('quick-shop-modal');
//   if (modal) {
//     modal.remove();
//     document.body.style.overflow = '';
//   }
// };

// const loadProductInModal = async (productHandle) => {
//   try {
//     const response = await fetch(`/products/${productHandle}.js`);
//     const product = await response.json();
    
//     const modalContent = document.getElementById('modal-content');
    
//     // Create product images section
//     const productImages = createProductImagesSection(product);
    
//     // Create product details section
//     const productDetails = createProductDetailsSection(product);
    
//     modalContent.innerHTML = productImages + productDetails;
    
//     // Initialize functionality
//     initializeColorSwatches();
//     initializeQuantitySelector();
//     initializeImageGallery();
//     initializeAddToBag(product);
    
//   } catch (error) {
//     console.error('Error loading product:', error);
//     document.getElementById('modal-content').innerHTML = `
//       <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
//         <p>Error loading product. Please try again.</p>
//       </div>
//     `;
//   }
// };

// const createProductImagesSection = (product) => {
//   const images = product.images || [product.featured_image];
  
//   return `
//     <div class="product-images" style="
//       flex: 1;
//       background: #f8f8f8;
//       display: flex;
//       flex-direction: column;
//       position: relative;
//     ">
//       <div style="
//         flex: 1;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         padding: 20px;
//       ">
//         <img id="main-product-image" 
//              src="${images[0]}" 
//              alt="${product.title}"
//              style="
//                max-width: 100%;
//                max-height: 100%;
//                object-fit: contain;
//                border-radius: 8px;
//              ">
//       </div>
      
//       ${images.length > 1 ? `
//         <div style="
//           padding: 10px 20px;
//           display: flex;
//           gap: 10px;
//           overflow-x: auto;
//           justify-content: center;
//         ">
//           ${images.map((img, index) => `
//             <img class="thumbnail ${index === 0 ? 'active' : ''}" 
//                  src="${img}" 
//                  data-src="${img}"
//                  style="
//                    width: 60px;
//                    height: 60px;
//                    object-fit: cover;
//                    border-radius: 4px;
//                    cursor: pointer;
//                    border: 2px solid ${index === 0 ? '#000' : 'transparent'};
//                    transition: border-color 0.2s;
//                  ">
//           `).join('')}
//         </div>
//       ` : ''}
//     </div>
//   `;
// };

// const createProductDetailsSection = (product) => {
//   const hasVariants = product.variants && product.variants.length > 1;
//   const firstVariant = product.variants[0];
  
//   // Create color options if variants exist
//   const colorOptions = hasVariants ? createColorOptions(product.variants) : '';
  
//   return `
//     <div class="product-details" style="
//       flex: 1;
//       padding: 30px;
//       display: flex;
//       flex-direction: column;
//       overflow-y: auto;
//     ">
//       ${product.tags && product.tags.includes('bestseller') ? `
//         <div style="
//           background: #000;
//           color: white;
//           padding: 4px 8px;
//           font-size: 11px;
//           font-weight: bold;
//           letter-spacing: 1px;
//           width: fit-content;
//           margin-bottom: 15px;
//         ">BESTSELLER</div>
//       ` : ''}
      
//       <h2 style="
//         font-size: 24px;
//         font-weight: bold;
//         margin: 0 0 10px 0;
//         line-height: 1.2;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       ">${product.title}</h2>
      
//       <div style="margin-bottom: 15px;">
//         <span style="font-size: 20px; font-weight: bold;">
//           ${formatPrice(firstVariant.price)}
//         </span>
//         ${firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price ? `
//           <span style="
//             font-size: 16px;
//             color: #999;
//             text-decoration: line-through;
//             margin-left: 10px;
//           ">${formatPrice(firstVariant.compare_at_price)}</span>
//         ` : ''}
//       </div>
      
//       <div style="
//         font-size: 14px;
//         color: #666;
//         margin-bottom: 20px;
//         cursor: pointer;
//         text-decoration: underline;
//       ">Shipping & Returns</div>
      
//       ${colorOptions}
      
//       <div style="margin: 25px 0;">
//         <div style="
//           display: flex;
//           align-items: center;
//           gap: 15px;
//           margin-bottom: 20px;
//         ">
//           <div class="quantity-selector">
//             <button class="quantity-btn" data-action="decrease">−</button>
//             <input type="number" class="quantity-input" value="1" min="1" max="10">
//             <button class="quantity-btn" data-action="increase">+</button>
//           </div>
          
//           <span id="price-display" style="
//             font-size: 18px;
//             font-weight: bold;
//           ">${formatPrice(firstVariant.price)}</span>
//         </div>
        
//         <button class="add-to-bag-btn" id="add-to-bag" ${!firstVariant.available ? 'disabled' : ''}>
//           ${firstVariant.available ? 'ADD TO BAG' : 'OUT OF STOCK'}
//         </button>
//       </div>
      
//       <div style="
//         font-size: 14px;
//         color: #666;
//         line-height: 1.5;
//         margin-top: 20px;
//       ">
//         ${product.description ? product.description.substring(0, 200) + '...' : ''}
//       </div>
//     </div>
//   `;
// };

// const createColorOptions = (variants) => {
//   // Group variants by color (assuming color is in the variant title)
//   const colors = [...new Set(variants.map(v => v.option1 || v.title))];
  
//   if (colors.length <= 1) return '';
  
//   return `
//     <div style="margin: 20px 0;">
//       <div style="
//         font-size: 14px;
//         font-weight: bold;
//         margin-bottom: 10px;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       ">Select Shade</div>
      
//       <div style="
//         display: flex;
//         flex-wrap: wrap;
//         gap: 5px;
//         max-height: 200px;
//         overflow-y: auto;
//       ">
//         ${colors.map((color, index) => {
//           const variant = variants.find(v => (v.option1 || v.title) === color);
//           const colorCode = getColorCode(color);
//           const isNew = Math.random() > 0.7; // Randomly mark some as new for demo
          
//           return `
//             <div class="color-swatch ${index === 0 ? 'selected' : ''} ${isNew ? 'new' : ''}" 
//                  data-variant-id="${variant.id}"
//                  data-color="${color}"
//                  data-price="${variant.price}"
//                  data-available="${variant.available}"
//                  title="${color}"
//                  style="background-color: ${colorCode};">
//             </div>
//           `;
//         }).join('')}
//       </div>
//     </div>
//   `;
// };

// const getColorCode = (colorName) => {
//   const colorMap = {
//     'red': '#dc2626',
//     'pink': '#ec4899',
//     'brown': '#92400e',
//     'nude': '#d4a574',
//     'coral': '#fb7185',
//     'berry': '#7c2d12',
//     'plum': '#6b21a8',
//     'mauve': '#a1a1aa'
//   };
  
//   const lowerColor = colorName.toLowerCase();
//   for (const [key, value] of Object.entries(colorMap)) {
//     if (lowerColor.includes(key)) return value;
//   }
  
//   // Generate color based on string hash for unknown colors
//   let hash = 0;
//   for (let i = 0; i < colorName.length; i++) {
//     hash = colorName.charCodeAt(i) + ((hash << 5) - hash);
//   }
//   const hue = Math.abs(hash) % 360;
//   return `hsl(${hue}, 60%, 50%)`;
// };

// const initializeColorSwatches = () => {
//   document.querySelectorAll('.color-swatch').forEach(swatch => {
//     swatch.addEventListener('click', function() {
//       // Remove selected class from all swatches
//       document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
      
//       // Add selected class to clicked swatch
//       this.classList.add('selected');
      
//       // Update price display
//       const price = this.dataset.price;
//       const isAvailable = this.dataset.available === 'true';
      
//       document.getElementById('price-display').textContent = formatPrice(price);
      
//       // Update add to bag button
//       const addToBagBtn = document.getElementById('add-to-bag');
//       addToBagBtn.disabled = !isAvailable;
//       addToBagBtn.textContent = isAvailable ? 'ADD TO BAG' : 'OUT OF STOCK';
//     });
//   });
// };

// const initializeQuantitySelector = () => {
//   const quantityInput = document.querySelector('.quantity-input');
//   const priceDisplay = document.getElementById('price-display');
  
//   document.querySelectorAll('.quantity-btn').forEach(btn => {
//     btn.addEventListener('click', function() {
//       const action = this.dataset.action;
//       let currentQty = parseInt(quantityInput.value) || 1;
      
//       if (action === 'increase' && currentQty < 10) {
//         currentQty++;
//       } else if (action === 'decrease' && currentQty > 1) {
//         currentQty--;
//       }
      
//       quantityInput.value = currentQty;
//       updatePriceDisplay();
//     });
//   });
  
//   quantityInput.addEventListener('change', updatePriceDisplay);
  
//   function updatePriceDisplay() {
//     const selectedSwatch = document.querySelector('.color-swatch.selected');
//     const basePrice = selectedSwatch ? selectedSwatch.dataset.price : document.querySelector('.color-swatch')?.dataset.price;
//     const quantity = parseInt(quantityInput.value) || 1;
    
//     if (basePrice) {
//       priceDisplay.textContent = formatPrice(basePrice * quantity);
//     }
//   }
// };

// const initializeImageGallery = () => {
//   document.querySelectorAll('.thumbnail').forEach(thumb => {
//     thumb.addEventListener('click', function() {
//       // Remove active class from all thumbnails
//       document.querySelectorAll('.thumbnail').forEach(t => {
//         t.classList.remove('active');
//         t.style.border = '2px solid transparent';
//       });
      
//       // Add active class to clicked thumbnail
//       this.classList.add('active');
//       this.style.border = '2px solid #000';
      
//       // Update main image
//       const mainImage = document.getElementById('main-product-image');
//       mainImage.src = this.dataset.src;
//     });
//   });
// };

// const initializeAddToBag = (product) => {
//   document.getElementById('add-to-bag').addEventListener('click', async function() {
//     if (this.disabled) return;
    
//     const selectedSwatch = document.querySelector('.color-swatch.selected');
//     const variantId = selectedSwatch ? selectedSwatch.dataset.variantId : product.variants[0].id;
//     const quantity = parseInt(document.querySelector('.quantity-input').value) || 1;
    
//     this.textContent = 'ADDING...';
//     this.disabled = true;
    
//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: quantity
//         })
//       });
      
//       if (response.ok) {
//         this.textContent = 'ADDED TO BAG ✓';
        
//         // Update cart count if exists
//         if (window.theme && window.theme.updateCartCount) {
//           window.theme.updateCartCount();
//         }
        
//         // Close modal after 1 second
//         setTimeout(() => {
//           closeQuickShopModal();
//         }, 1000);
//       } else {
//         throw new Error('Failed to add to cart');
//       }
//     } catch (error) {
//       console.error('Error adding to cart:', error);
//       this.textContent = 'ERROR - TRY AGAIN';
//       this.disabled = false;
//     }
//   });
// };

// const formatPrice = (priceInCents) => {
//   return new Intl.NumberFormat('en-GB', {
//     style: 'currency',
//     currency: 'GBP'
//   }).format(priceInCents / 100);
// };

// // Tolstoy integration (keep existing code)
// const subscribeToQuickShopClick = () => {
//   window.tolstoyWidget.subscribe(
//     "tolstoy_spotlight_carousel_quick_shop_click",
//     (o) => {
//       o.product && o.product.handle 
//         ? openQuickShopModal(o.product) 
//         : console.error("Product handle is not available in the event");
//     },
//     { disableDefault: true }
//   );
// };

// window.tolstoyWidget 
//   ? subscribeToQuickShopClick() 
//   : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);